import * as React from 'react';
import { useSelector } from 'react-redux';
import { BanksSlider as BanksSliderComponent } from '../../components/BanksSlider';
import { getFilters, getOtherBanks } from '../../selectors';

export function BanksSlider() {
  const { location } = useSelector(getFilters);
  const otherBanks = useSelector(getOtherBanks);

  return <BanksSliderComponent otherBanks={otherBanks} locationId={location} />;
}
